import React from "react";
import ProjectList from "../technical/ProjectList";

const FIRRequests = () => {
    return <ProjectList status="all" title="Client Requests" source="FIR" />;
};

export default FIRRequests;
